import { Box, Grid, TextField } from "@mui/material";
import { calendarData, calendarHead, } from "../../../mock-data/calendar-table-mock";
import ActionHeader from "../../../UI/action-header/action-header";
import GlobalTable from "../../../UI/global-table/global-table";
import edit from "../../../assets/setting/Calendar/edit.png";
import add from "../../../assets/setting/Calendar/add.png";
import cross from "../../../assets/setting/Calendar/cross.png";
import click from "../../../assets/setting/Calendar/click.png";
import { useState } from "react";
import GlobalCard from "../../../UI/card/GlobalCard";
import AddCustomizedModal from "./add-customized-modal";

const CalendarTable = () => {
    const [calendarName, setCalendarName] = useState({ isName: false, name: 'PK Team Calendar', isDesc: false, description: 'Pakistani Employees' })
    const [showAddModal, setShowAddModal] = useState(false);
    return (
        <div>
            <Box sx={{ mb: "30px" }}>
                <ActionHeader heading="Add Customized Vacation" buttonImg="" />
            </Box>
            <GlobalCard>
                <Grid container justifyContent="space-between">
                    <Grid item lg={3.2} md={5} xs={12} >
                        {!calendarName.isName ? (
                            <div className="flex-center-between">
                                <p className="fs-16 fw-500 lh-22" style={{ color: "#14142B" }}>
                                    {calendarName.name}
                                </p>
                                <img
                                    src={edit}
                                    alt="icon"
                                    className="cursor-pointer"
                                    onClick={() => {
                                        setCalendarName({ ...calendarName, isName: true });
                                    }}
                                />
                            </div>
                        ) : (
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                border="1.5px solid #CCCCCC"
                                borderRadius="5px"
                            >
                                <TextField
                                    size="small"
                                    fullWidth
                                    type="text"
                                    name="calendar name"
                                    value={calendarName.name}
                                    onChange={(e) => setCalendarName({ ...calendarName, name: e.target.value })}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#ffff",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#ffff",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#ffff",
                                            },
                                        },
                                    }}
                                />
                                <div style={{ display: "flex" }}>
                                    <img src={cross} alt="cross" className="cursor-pointer" />
                                    <img
                                        src={click}
                                        alt="click"
                                        className="cursor-pointer"
                                        onClick={() => setCalendarName({ ...calendarName, isName: false })}
                                        style={{ marginInline: "15px" }}
                                    />
                                </div>
                            </Box>
                        )}
                        {!calendarName.isDesc ? <div className="flex-center-between" style={{ marginBlock: '30px' }}>
                            <p className="fs-16 fw-500 lh-28" style={{ color: "#14142B" }}>
                                Description: {calendarName.description}
                            </p>
                            <img src={edit} alt="icon" className="cursor-pointer" onClick={() => setCalendarName({ ...calendarName, isDesc: true })} />
                        </div> :
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                border="1.5px solid #CCCCCC"
                                borderRadius="5px"
                                sx={{ my: '15px' }}
                            >
                                <TextField
                                    size="small"
                                    fullWidth
                                    type="text"
                                    name="calendar description"
                                    value={calendarName.description}
                                    onChange={(e) => setCalendarName({ ...calendarName, description: e.target.value })}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#ffff",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#ffff",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#ffff",
                                            },
                                        },
                                    }}
                                />
                                <div style={{ display: "flex" }}>
                                    <img src={cross} alt="cross" className="cursor-pointer" />
                                    <img
                                        src={click}
                                        alt="click"
                                        className="cursor-pointer"
                                        onClick={() => setCalendarName({ ...calendarName, isDesc: false })}
                                        style={{ marginInline: "15px" }}
                                    />
                                </div>
                            </Box>
                        }
                    </Grid>

                    <Grid
                        item
                        lg={3.2} md={5} xs={12}
                        justifyContent={{ md: "end", xs: "start" }}
                    >
                        <div className="d-flex align-center justify-end" >
                            <img src={add} alt="add" className="cursor-pointer" />
                            <p
                                className="cursor-pointer"
                                onClick={() => setShowAddModal(true)}
                                style={{ color: "#F78812", paddingLeft: "11px" }}
                            >
                                Add Customised Vacation
                            </p>
                        </div>
                    </Grid>
                </Grid>
                <GlobalTable
                    theadData={calendarHead}
                    tableData={calendarData}
                    type="pk team calendar"
                    role="admin"
                />
            </GlobalCard>
            <AddCustomizedModal showAddModal={showAddModal} setShowAddModal={setShowAddModal} />
        </div>
    );
};
export default CalendarTable;